var styleDataHash = "97da73b0";
const injectCss = () => {
  var css = `.KsqQk,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.DGZJj{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .DGZJj{background-color:#fff}.DGZJj.uledU{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.DGZJj{height:47px}}}@container (width < 640px){.DGZJj{height:47px}}.DGZJj .-qtXQ{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;grid-gap:12px}[dir=ltr] .DGZJj .-qtXQ,[dir=rtl] .DGZJj .-qtXQ{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.DGZJj .-qtXQ.GHqIn{grid-auto-columns:auto}}}@container (width < 640px){.DGZJj .-qtXQ.GHqIn{grid-auto-columns:auto}}.DGZJj .-qtXQ .OPATE{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){.DGZJj .-qtXQ .OPATE{display:flex;width:100%}}}@container (width < 640px){.DGZJj .-qtXQ .OPATE{display:flex;width:100%}}.DGZJj .-qtXQ .FGXyv{display:grid;grid-auto-flow:row}.DGZJj .-qtXQ .FGXyv .l3w5W{font-size:14px}.DGZJj .-qtXQ .FGXyv .ZPtNw{color:#646464;font-size:12px}.DGZJj .-qtXQ .gupDB{align-self:right}.DGZJj.uledU,.DGZJj:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .DGZJj.uledU,[dir] .DGZJj:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.DGZJj.uledU svg,.DGZJj:active svg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .DGZJj:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "KsqQk",
  "container": "DGZJj",
  "selected": "uledU",
  "content": "-qtXQ",
  "content_mobile_alignCenter": "GHqIn",
  "prefix": "OPATE",
  "titleWrapper": "FGXyv",
  "title": "l3w5W",
  "subtitle": "ZPtNw",
  "suffix": "gupDB"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
